import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AddVehicle from "@/pages/AddVehicle";
import VehicleDetail from "@/pages/VehicleDetail";
import AlertDetail from "@/pages/AlertDetail";
import Scan from "@/pages/Scan";
import Report from "@/pages/Report";
import ScanSuccess from "@/pages/ScanSuccess";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen grid place-items-center text-gray-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/dashboard/vehicles/new" element={<Protected><AddVehicle /></Protected>} />
          <Route path="/dashboard/vehicles/:id" element={<Protected><VehicleDetail /></Protected>} />
          <Route path="/dashboard/alerts/:id" element={<Protected><AlertDetail /></Protected>} />
          <Route path="/s/:cardCode" element={<Scan />} />
          <Route path="/s/:cardCode/report" element={<Report />} />
          <Route path="/s/:cardCode/success" element={<ScanSuccess />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
